import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import ResetData from '../resetData';
import BundledPricing from '../bundledPricing';
import updateTableRows from '../../services/updateTableRows';
import updateBundledPricing from '../../services/updateBundledPricing';
import resizeTableHeader from '../../services/resizeTableHeader';
import {
  actionUpdateBundledPricing,
  actionUpdateTableData,
} from '../../actions';

/**
 * CSS got to disable eslint, as the import catchers yell at you...
 */
/* eslint-disable */
import '!!style!css!postcss!sass!../../../node_modules/ag-grid/dist/styles/ag-grid.css';
import '!!style!css!postcss!sass!./ag-theme-neiman.scss';
/* eslint-enable */

class Table extends Component {
  constructor() {
    super();
    this.exportData = this.exportData.bind(this);

    this.tableHeaderSize = {
      headerHeight: 75,
      parentHeight: 45,
    };

    this.onCellValueChanged = this.onCellValueChanged.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onRowDataChanged = this.onRowDataChanged.bind(this);
    this.onGridSizeChanged = this.onGridSizeChanged.bind(this);
    this.onColumnGroupOpened = this.onColumnGroupOpened.bind(this);
  }

  onCellValueChanged(params) {
    const rowIndex = params.node.rowIndex;
    const field = params.colDef.field;
    const newValue =
      isNaN(params.newValue) || !params.newValue.trim().length ?
        params.oldValue :
        params.newValue;
    const rows = params.api.rowModel.rowsToDisplay;

    // For Percent, if we are on row 0, we do not update it.
    const baseRowUpdateObj = {
      [field]: 'percent' === field && 0 === rowIndex ? 100 : newValue,
    };

    updateTableRows[field](
      params.api,
      rowIndex,
      field,
      newValue,
      rows,
      baseRowUpdateObj,
      this.props.defaultData
    );

    this.props.tableData(
      params.api.rowModel.rowsToDisplay.map((row) => row.data)
    );
  }

  onGridReady({ api }) {
    // Attaching API for access reasons
    this.api = api;
    this.props.bundledPrice(updateBundledPricing(api));
    resizeTableHeader(this.api, this.tableHeaderSize);
  }

  onRowDataChanged() {
    setTimeout(
      () => this.props.bundledPrice(updateBundledPricing(this.api)),
      0
    );
  }

  onGridSizeChanged() {
    if (!this.api) {
      return;
    }

    resizeTableHeader(this.api, this.tableHeaderSize);
  }

  onColumnGroupOpened() {
    resizeTableHeader(this.api, this.tableHeaderSize);
  }

  exportData() {
    const {
      weightedProfessional,
      weightedTechnical,
      weightedGlobal,
    } = Object.keys(this.props.bundledPricing).reduce(
      (acc, curr) => (
        { ...acc, [curr]: this.props.bundledPricing[curr].replace('$', '') }
      ),
    {});
    const customFooter = [
      '\n',
      `"Weighted Professional Bundled Price","${weightedProfessional}"`,
      `"Weighted Technical Bundled Price","${weightedTechnical}"`,
      `"Weighted Global Bundled Price","${weightedGlobal}"`,
    ].join('\n');
    this.api.exportDataAsCsv({ customFooter });
  }

  render() {
    const rowHeight = 60;
    const wrapperStyle = {
      height:
        this.tableHeaderSize.headerHeight +
        this.tableHeaderSize.parentHeight +
        (this.props.defaultData.length * rowHeight),
      // Take all columns, minus the hidden ones and set the width
      // add 2 for borders
      width: this.props.table.columnDefs
        .reduce((acc, curr) => (
          curr.children ? acc.concat(curr.children) : acc.concat([curr])
        ), [])
        .reduce((acc, curr) => (acc +
          (curr.hide || 'open' === curr.columnGroupShow ? 0 : curr.width)
        ), 0) + 2,
    };

    const buttonGroupStyle = { width: wrapperStyle.width };

    return (
      <div style={buttonGroupStyle}>
        <div>
          <div className="button-group">
            <ResetData />
            <button onClick={this.exportData}>Download Data</button>
          </div>
          <div className="ag-neiman" style={wrapperStyle}>
            <AgGridReact
              {...this.props.table}
              onCellValueChanged={this.onCellValueChanged}
              onGridReady={this.onGridReady}
              onRowDataChanged={this.onRowDataChanged}
              onGridSizeChanged={this.onGridSizeChanged}
              onColumnGroupOpened={this.onColumnGroupOpened}
              onRo={this.onRo}
              headerHeight={this.tableHeaderSize.headerHeight}
              rowHeight={rowHeight}
              singleClickEdit
              suppressMovableColumns
            />
          </div>
          <BundledPricing />
          <button
            style={buttonGroupStyle}
            onClick={this.exportData}
          >
            Download Data
          </button>
        </div>
      </div>
    );
  }
}

Table.propTypes = {
  bundledPrice: PropTypes.func.isRequired,
  tableData: PropTypes.func.isRequired,
  table: PropTypes.shape({
    rowData: PropTypes.array.isRequired,
    columnDefs: PropTypes.array.isRequired,
  }).isRequired,
  bundledPricing: PropTypes.object,
  defaultData: PropTypes.array.isRequired,
};

const mapStateToProps = ({ table }) => ({
  table,
  defaultData: table.defaultData,
  bundledPricing: table.bundledPricing,
});

const mapDispatchToProps = (dispatch) => ({
  bundledPrice: (data) => dispatch(actionUpdateBundledPricing(data)),
  tableData: (data) => dispatch(actionUpdateTableData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);



// WEBPACK FOOTER //
// ./app/components/table/index.js